// Override for local development: REACT_APP_API_BASE_URL=http://localhost:8080/api npm start
export const baseUrl = process.env.REACT_APP_API_BASE_URL || "https://qualicheck.logic-services.com/api";
